// extracted by mini-css-extract-plugin
module.exports = {"comment":"_2lxtJ","text":"_3y116"};